import React from 'react';

export default function Pagination({ page, totalPages, total, limit, onPageChange }) {
  if (!totalPages || totalPages <= 0) return null;

  const start = (page - 1) * limit + 1;
  const end   = Math.min(page * limit, total);

  // Build the page numbers to show (max 5 with ellipsis)
  const pages = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else if (page <= 3) {
    pages.push(1, 2, 3, 4, 5, '...', totalPages);
  } else if (page >= totalPages - 2) {
    pages.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
  } else {
    pages.push(1, '...', page - 1, page, page + 1, '...', totalPages);
  }

  const btnBase = {
    padding: '4px 10px', borderRadius: 6, fontSize: 12, border: '1px solid var(--border)',
    cursor: 'pointer', background: 'var(--bg2)', color: 'var(--text2)',
    display: 'inline-flex', alignItems: 'center',
  };
  const btnActive = { ...btnBase, background: 'var(--accent)', color: '#000', fontWeight: 700, borderColor: 'var(--accent)' };
  const btnDisabled = { ...btnBase, opacity: 0.4, cursor: 'default' };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 16, flexWrap: 'wrap', gap: 8 }}>
      <div style={{ fontSize: 12, color: 'var(--text3)' }}>
        {total === 0 ? 'No records found for this period' : `Showing ${start}–${end} of ${total}`}
      </div>
      {totalPages > 1 && (
        <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
          <button
            style={page === 1 ? btnDisabled : btnBase}
            disabled={page === 1}
            onClick={() => onPageChange(page - 1)}
          >← Prev</button>

          {pages.map((p, i) =>
            p === '...'
              ? <span key={`ellipsis-${i}`} style={{ padding: '4px 6px', color: 'var(--text3)', fontSize: 12 }}>…</span>
              : <button
                  key={p}
                  style={p === page ? btnActive : btnBase}
                  onClick={() => p !== page && onPageChange(p)}
                >{p}</button>
          )}

          <button
            style={page === totalPages ? btnDisabled : btnBase}
            disabled={page === totalPages}
            onClick={() => onPageChange(page + 1)}
          >Next →</button>
        </div>
      )}
    </div>
  );
}
